export default {
  Title      : 'E. Value of Equity',
  HeaderTitle: 'Economic Value of Equity',
  Tab        : {
    RegulatoryThresholds: {
      Title: 'Regulatory Thresholds',
      Slug : 'regulatory-thresholds'
    },
    InternalThresholds: {
      Title: 'Internal Thresholds',
      Slug : 'internal-thresholds'
    },
    BaselTests: {
      Title: 'Basel Tests',
      Slug : 'basel-tests'
    },
    HistoricalEVEChanges: {
      Title: 'Historical EVE Changes',
      Slug : 'historical-eve-changes'
    },
    SharpestEVEChanges: {
      Title: 'Sharpest EVE Changes',
      Slug : 'sharpest-eve-changes'
    }
  },
  Section: {
    RegulatoryThresholds: {
      Title  : 'Basel Tests: Threshold Study',
      Tooltip: 'MISSING TOOLTIP'
    },
    InternalThresholds: {
      NevLimits: {
        Title  : 'EVE Limits',
        Tooltip: 'MISSING TOOLTIP'
      }
    },
    BaselTests: {
      Title  : 'Basel Tests: Threshold Study',
      Tooltip: 'MISSING TOOLTIP',
      Blocks : {
        TotalEveChange: 'Total EVE Change',
        TableHeaders  : {
          PresentValue: 'Present Value',
          Base        : 'Base',
          Shock       : 'Shock',
          Delta       : 'Δ'
        },
        TableRows: {
          FixedDeposits         : 'Fixed Deposits',
          FixedLoans            : 'Fixed Loans',
          FloatingLoans         : 'Floating Loans',
          BehavDeposits         : 'Behav. Deposits',
          TotalEve              : 'Total EVE',
          FixedInvestments      : 'Fixed Investments',
          FloatingInvestments   : 'Floating Investments',
          FixedIrsAssets        : 'Fixed IRS Assets',
          FloatingIrsAssets     : 'Floating IRS Assets',
          FixedIrsLiabilities   : 'Fixed IRS Liabilities',
          FloatingIrsLiabilities: 'Floating IRS Liabilities',
          Cash                  : 'Cash'
        }
      }
    },
    HistoricalEVEChanges: {
      Blocks: {
        EveOfCurrentBankProfile: {
          Title: 'EVE of Current Bank Profile'
        },
        SOFRRate: {
          Title: 'Fed Funds Rate'
        }
      }
    },
    SharpestEVEChanges: {
      Title : 'Sharpest EVE Changes',
      Blocks: {
        Largest3MonthMove: {
          Title: 'Largest 3month Move'
        },
        Largest6MonthMove: {
          Title: 'Largest 6month Move'
        },
        PositiveChange: 'EVE positive change',
        NegativeChange: 'EVE negative change'
      }
    }
  }
}
